import { render, staticRenderFns } from "./inventoryGroups.vue?vue&type=template&id=b77dc4e2&"
import script from "./inventoryGroups.vue?vue&type=script&lang=js&"
export * from "./inventoryGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports